/*
  Map description:

  key - uses as parameter in actions.models.modals[open|update|close]

  value - must equals the name of component in components/modals directory

 */

// @deprecated
const modals = {
  Dialog: 'DialogModal',
  SomethingWentWrong: 'SomethingWentWrongModal',
  ServerError: 'ServerErrorModal',
  ChangesSaveSuccess: 'ChangesSaveSuccessModal',
  CardUpdateSuccess: 'CardUpdateSuccessModal',
  ProductDetails: 'ProductDetailsModal',
  NewProductDetails: 'NewProductDetailsModal',
  SameFragranceError: 'SameFragranceErrorModal',
  RedeemConfirmation: 'RedeemConfirmationModal',
  RedeemSuccess: 'RedeemSuccessModal',
  QuizStart: 'QuizStartModal',
  PickDate: 'PickDateModal',
  MembershipInfo: 'MembershipInfoModal',
  FirstTimeVisit: 'FirstTimeVisitModal',

  // Queue
  HowQueueWorks: 'HowQueueWorksModal',

  // New products
  newProducts: {
    Makeup: 'MakeupModal',
    Skincare: 'SkincareModal',
    LipBalms: 'LipBalmsModal',
  },

  // Skip a Month
  SkipAMonth: 'SkipAMonthModal',
  SkipAMonthSuccess: 'SkipAMonthSuccessModal',

  UnskipSuccess: 'UnskipSuccessModal',

  // Update PayPal
  ErrorPayPal: 'ErrorPayPalModal',
  ErrorCard: 'ErrorCardModal',
  AlreadyUpdatedToPayPal: 'AlreadyUpdatedToPayPalModal',

  // Upgrade Subscription
  UpgradeSubscription: 'UpgradeSubscriptionModal',
  QueueUpgrade: 'QueueUpgradeModal',

  // Cancel Subscription
  cancelSubscription: {
    CancelSubscription: 'CancelSubscriptionModal',
    BeforeYouGo: 'BeforeYouGoModal',
    OneLastQuestion: 'OneLastQuestionModal',
    SubscriptionWasCancelled: 'SubscriptionWasCancelledModal',
    ProlongOffer: 'ProlongOfferModal',
    ProlongThankYou: 'ProlongThankYouModal',
    PauseSubscription: 'PauseSubscriptionModal',
    UnpauseRequired: 'UnpauseRequiredModal',
    UnsubscribeProducts: 'UnsubscribeProductsModal',
    Refund: 'RefundModal',
    RefundOnTheDayOfCharge: 'RefundOnTheDayOfCharge',
    Feedback: 'FeedbackModal',
    // humble
    offerTest25off: 'OfferTest25offModal',
    offerTest25offSuccess: 'OfferTest25offSuccessModal',
    FeedbackFormFail: 'FeedbackErrorModal',
  },

  // Smart Search
  WeMissedYou: 'WeMissedYouModal',
  TryTwoThreeFragrances: 'TryTwoThreeFragrancesModal',

  // Prepaid Card
  prepaidCard: {
    PrepaidCardWithSubscriptionPlans: 'PrepaidCardWithSubscriptionPlansModal',
    PrepaidCardWithDiscount: 'PrepaidCardWithDiscountModal',
  },

  // Resubscribe
  resubscribe: {
    GetBackTogether: 'GetBackTogetherModal', // TODO remove this modal?
    ResubscribeWithDiscount: 'ResubscribeWithDiscountModal', // TODO remove this modal?
    SuccessfullyResubscribed: 'SuccessfullyResubscribedModal',
    ResubscribeSuccess: 'ResubscribeSuccessModal',
    ReactivateSubscription: 'ReactivateSubscriptionModal',
  },

  // Gift Sets
  GiftSetQuickView: 'GiftSetQuickViewModal',

  // Gift
  gifts: {
    SetGiftDate: 'SetGiftDateModal',
    ChooseGiftSize: 'ChooseGiftSizeModal',
    ChooseGiftCardSkin: 'ChooseGiftCardSkinModal',
    ChooseGiftCardValue: 'ChooseGiftCardValueModal',
    SetGiftRecipientInfo: 'SetGiftRecipientInfoModal',
    ChooseGiftCardDeliveryType: 'ChooseGiftCardDeliveryTypeModal',
    GiftRedeemed: 'GiftRedeemedModal',
  },

  // Review
  review: {
    ReviewItemList: 'ReviewItemListModal',
    ReviewComposer: 'ReviewComposerModal',
    ReviewEdit: 'ReviewEditModal',
    ReviewTags: 'ReviewTagsModal',
    LoginRequired: 'LoginRequiredModal',
    Recommendations: 'RecommendationsModal',
    IncubatorReviewEdit: 'IncubatorReviewEditModal',
  },

  // Pause Subscription
  pauseSubscription: {
    UnpauseSubscription: 'UnpauseSubscriptionModal',
    PauseSuccess: 'PauseSuccessModal',
    PauseOneMonthSuccess: 'PauseOneMonthSuccessModal',
  },

  // Invite
  ChooseFriendsToInvite: 'ChooseFriendsToInviteModal',

  // Register
  FacebookRegister: 'FacebookRegisterModal',
  RemindPassword: 'RemindPasswordModal',

  // Password
  ShortPassword: 'ShortPasswordModal',

  // ThankYou
  ThankYouQueue: 'ThankYouQueueModal',

  // Products
  RecommendationTag: 'RecommendationTagModal',
  NoteRecommendations: 'NoteRecommendationsModal',

  // Payment
  AddressValidation: 'AddressValidationModal',
  ErrorCVV: 'ErrorCVVModal',
  LeavePayment: 'LeavePaymentModal',

  // Downgrade
  PreparingDowngrade: 'PreparingDowngradeModal',
  AlreadyDowngrade: 'AlreadyDowngradeModal',

  // Limited Edition Products
  limitedEditionProducts: {
    NeedUpdateCard: 'NeedUpdateCardModal',
    NeedUpdateAddress: 'NeedUpdateAddressModal',
    NeedChangeFrequency: 'NeedChangeFrequencyModal',
    NeedResubscribe: 'NeedResubscribeModal',
    NeedSubscribe: 'NeedSubscribeModal',
    NeedUnpause: 'NeedUnpauseModal',
    NeedUnskip: 'NeedUnskipModal',
    OutOfStock: 'OutOfStockModal',
    OutOfStockNotify: 'OutOfStockNotifyModal',
    PutFirstInQueue: 'PutFirstInQueueModal',
  },

  premiumProducts: {
    WelcomeBack: 'WelcomeBackModal',
    AddedProduct: 'AddedProductModal',
    NeedCardUpdate: 'NeedCardUpdateModal',
    NeedPaymentData: 'NeedPaymentDataModal',
    NeedSubscription: 'NeedSubscriptionModal',
  },

  SkincareProductDetails: 'SkincareProductDetailsModal',


  // Humble --------------------------------------------------------- /

  humble: {
    ServerError: 'HumbleServerErrorModal',
    FlashSaleExpired: 'FlashSaleExpiredModal',
    FeedbackFormSuccess: 'FeedbackSuccessModal',
    flashSale: 'FlashSaleModal',
    tossIn: 'TossInModal',

    verifyShippingAddress: 'VerifyShippingAddressModal',
    undeliverableAddress: 'UndeliverableAddressModal',
  },
}


export default modals
